/**
 * REWE Digital GmbH.
 * IT-Verticals
 * zr-badges
 */

$component: 'zr-badges';

:host {
    position: absolute;
    max-width: 120px;
    z-index: 1;
    top: 8px;
    left: 0;
}
